export default __webpack_public_path__ + "static/media/symbol.9cc2570e.svg";